import * as tslib_1 from "tslib";
import { DiffuseBasicChunk } from "./DiffuseBasicChunk";
/**
 * DiffuseWrapChunk is an alternative to DiffuseBasicChunk in which the light is allowed to be "wrapped around" the normally dark area, to some extent.
 * It can be used as a crude approximation to Oren-Nayar or simple subsurface scattering.
 */
var DiffuseWrapChunk = (function (_super) {
    tslib_1.__extends(DiffuseWrapChunk, _super);
    /**
     * Creates a new DiffuseWrapChunk object.
     */
    function DiffuseWrapChunk(method, shader) {
        return _super.call(this, method, shader) || this;
    }
    /**
     * @inheritDoc
     */
    DiffuseWrapChunk.prototype._cleanCompilationData = function () {
        _super.prototype._cleanCompilationData.call(this);
        this._wrapDataRegister = null;
    };
    /**
     * @inheritDoc
     */
    DiffuseWrapChunk.prototype._getFragmentPreLightingCode = function (registerCache, sharedRegisters) {
        var code = _super.prototype._getFragmentPreLightingCode.call(this, registerCache, sharedRegisters);
        this._pIsFirstLight = true;
        this._wrapDataRegister = registerCache.getFreeFragmentConstant();
        this._wrapDataIndex = this._wrapDataRegister.index * 4;
        return code;
    };
    /**
     * @inheritDoc
     */
    DiffuseWrapChunk.prototype._getFragmentCodePerLight = function (lightDirReg, lightColReg, registerCache, sharedRegisters) {
        var code = "";
        var t;
        // write in temporary if not first light, so we can add to total diffuse colour
        if (this._pIsFirstLight) {
            t = this._totalLightColorReg;
        }
        else {
            t = registerCache.getFreeFragmentVectorTemp();
            registerCache.addFragmentTempUsages(t, 1);
        }
        code += "dp3 " + t + ".x, " + lightDirReg + ".xyz, " + sharedRegisters.normalFragment + ".xyz\n" +
            "add " + t + ".y, " + t + ".x, " + this._wrapDataRegister + ".x\n" +
            "mul " + t + ".y, " + t + ".y, " + this._wrapDataRegister + ".y\n" +
            "sat " + t + ".w, " + t + ".y\n" +
            "mul " + t + ".xz, " + t + ".w, " + lightDirReg + ".wz\n";
        if (this._modulateFunction != null)
            code += this._modulateFunction(lightDirReg, registerCache, sharedRegisters);
        code += "mul " + t + ", " + t + ".x, " + lightColReg + "\n";
        if (!this._pIsFirstLight) {
            code += "add " + this._totalLightColorReg + ".xyz, " + this._totalLightColorReg + ".xyz, " + t + ".xyz\n";
            registerCache.removeFragmentTempUsage(t);
        }
        this._pIsFirstLight = false;
        return code;
    };
    /**
     * @inheritDoc
     */
    DiffuseWrapChunk.prototype._activate = function () {
        _super.prototype._activate.call(this);
        if (this._invalid) {
            var index = this._wrapDataIndex;
            var data = this._shader.fragmentConstantData;
            data[index] = this._method.wrapFactor;
            data[index + 1] = 1 / (this._method.wrapFactor + 1);
        }
    };
    return DiffuseWrapChunk;
}(DiffuseBasicChunk));
export { DiffuseWrapChunk };



// WEBPACK FOOTER //
// ../dist/lib/chunks/DiffuseWrapChunk.js